(function ($) {
	$(document).ready(function () {
		/*
		 * Modify old markup in product descriptions (will need to remove after reformat)
		 */
		const productParagraphs = document.querySelectorAll(
			".rte.text-theme-basic.text-left p"
		);

		if (productParagraphs != "") {
			for (i = 0; i < productParagraphs.length; i++) {
				const para = productParagraphs[i];

				if (
					para.innerHTML.includes("|--split--|") ||
					para.innerHTML.includes("|--static--|")
				) {
					para.style.display = "none";
					para.innerHTML = "";
				}

				if (
					para.innerHTML.includes("Ingredients") ||
					para.innerHTML.includes("Nutrition Facts")
				) {
					para.style.fontWeight = "900";
					para.style.marginTop = "1em";
				}
			}
		}

		/*
		 * Modify Recipe table icons
		 */
		const recipeTableIcons = document.querySelectorAll(
			".recipe_table tbody tr td.recipe_table_cell i"
		);

		if (recipeTableIcons != "") {
			for (i = 0; i < recipeTableIcons.length; i++) {
				const icon = recipeTableIcons[i];

				if (icon.classList.contains("fa-clock-o")) {
					icon.classList.replace("fa-clock-o", "fa-clock");
				}
			}
		}

		/*
		 * Relatable edit > display only 4 items and shuffle them on reload
		 */
		function hideExtraItems() {
			const relatedItems = document.querySelectorAll("#related-list li");

			if (relatedItems != null && relatedItems.length > 0) {
				for (i = 0; i < relatedItems.length; i++) {
					let item = relatedItems[i];
					if (i >= 4) {
						item.classList.add("hidden");
						item.style.display = "none";
						item.style.opacity = "0%";
					}
				}
			}
		}

		setTimeout(hideExtraItems, 500);

		function shuffleItems() {
			const relatedItem = document.querySelector("#related-list");

			if (relatedItem != null && relatedItem.length > 0) {
				for (var i = relatedItem.children.length; i >= 0; i--) {
					relatedItem.appendChild(
						relatedItem.children[(Math.random() * i) | 0]
					);
				}
			}
		}

		setTimeout(shuffleItems, 500);

		/*
		 * Blog tag filter as dropdown with functionality
		 */
		const blogTag = document.getElementById("blog-tags");

		if (blogTag != null && blogTag.length > 0) {
			blogTag.onchange = function () {
				let blogTags = this.options[this.selectedIndex];

				if (blogTags.value != "") {
					window.location = blogTags.value;
				}
			};
		}

		window.addEventListener("load", (event) => {
			let currentURL = window.location.href;

			const _blogTags = $("#blog-tags option");

			_blogTags.each(function (i) {
				let _this = $(this);
				let _value = _this.val();

				if (_value === currentURL) {
					_this.attr("aria-selected", "true");
					_this.prop("selected", -1);
				}
			});
		});
	});
    /*
     * Recipe Printing Functionality
     */
    if( $('#print-recipe').length > 0 ){
       $('#print-recipe').click(function(){
        $('#recipe-container').print({
            addGlobalStyles : true,
            stylesheet : null,
            rejectWindow : true,
            noPrintSelector : ".no-print",
            iframe : true,
            append : null,
            prepend : null
        });
      }) 
    }
})(jQuery);

function getCartData() {
	return new Promise(function (resolve, reject) {
		$.getJSON("/cart.js", function (cart) {
			resolve(cart);
		});
	});
}

var progressBar = {
	update: function () {
		getCartData().then(function (data) {
      let progressBarTotal = 0;

      data.items.forEach(item => {
        if (item.product_type == 'Gift Card') {
          return true;
        }

        progressBarTotal += item.final_line_price;
      });

			let freeShippingStatus = document.querySelector(
				"[data-free-shipping-status]"
			);
			let freeShippingRemainingAmount = document.querySelector(
				"[data-free-shipping-remaining]"
			);

			if (data.quantity == 0) {
				freeShippingStatus.setAttribute("data-free-shipping-status", "normal");
			} else if (progressBarTotal >= 5000) {
				freeShippingStatus.setAttribute("data-free-shipping-status", "true");
			} else {
				freeShippingStatus.setAttribute("data-free-shipping-status", "false");
			}

			freeShippingRemainingAmount.innerHTML = formatMoney( 5000 - progressBarTotal );

			document.getElementsByTagName("progress")[0].value = progressBarTotal;
		});
	},
};

const rcContainer = document.querySelector('.recharge-subscription-widget');
const productPrice = document.querySelector('button.add-to-cart-btn [data-product-price]');
const productSubscriptionPrice = document.querySelector('button.add-to-cart-btn [data-product-subscription-price]');
let sellingPlanInput = document.querySelector('.shopify-product-form input[name="selling_plan"]');

setTimeout(() => {
    if (rcContainer) {
        // Function to update visibility based on input value
        const updateVisibility = () => {
            let val = sellingPlanInput.value;
            if (val === '') {
                productPrice.classList.remove('hidden');
                productSubscriptionPrice.classList.add('hidden');
            } else {
                productPrice.classList.add('hidden');
                productSubscriptionPrice.classList.remove('hidden');
            }
        };

        // Initial check on load
        updateVisibility();

        // Add event listener to input for change events
        sellingPlanInput.addEventListener('input', updateVisibility);

        // Select all radio buttons and attach click event listeners
        let widgets = rcContainer.querySelectorAll('.rc-widget .rc-template__radio .rc-radio');
        widgets.forEach((widget) => {
            widget.addEventListener('click', () => {
                // Check if the clicked widget has specific classes
				if( widget.classList.contains('onetime-radio') ){
					productPrice.classList.remove('hidden');
                    productSubscriptionPrice.classList.add('hidden');
				}

                if (widget.classList.contains('subscription-radio') ) {
                    productPrice.classList.add('hidden');
                    productSubscriptionPrice.classList.remove('hidden');
                }
            });
        });
    }
}, 2000);